<template>
  <nav class="navbar">
    <div class="nav-content">
      <div class="nav-brand">
        <router-link to="/" class="brand-title">一杯吃吃的小窝</router-link>
      </div>
      <div class="nav-links">
        <router-link to="/" class="nav-item">
          <i class="nav-icon">🏠</i>
          <span>主页</span>
        </router-link>
        <router-link to="/dynamic" class="nav-item">
          <i class="nav-icon">📢</i>
          <span>动态</span>
        </router-link>
        <router-link to="/replay" class="nav-item">
          <i class="nav-icon">📺</i>
          <span>录播</span>
        </router-link>
        <router-link to="/creation" class="nav-item">
          <i class="nav-icon">✨</i>
          <span>创作</span>
        </router-link>
        <router-link to="/fan-creation" class="nav-item">
          <i class="nav-icon">🎨</i>
          <span>二创</span>
        </router-link>
        <router-link to="/daughters" class="nav-item">
          <i class="nav-icon">👧</i>
          <span>女儿们</span>
        </router-link>
        <router-link to="/merch" class="nav-item">
          <i class="nav-icon">🎁</i>
          <span>周边</span>
        </router-link>
        <router-link to="/galgame" class="nav-item">
          <i class="nav-icon">🎮</i>
          <span>Galgame</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HeaderNav'
})
</script>

<style scoped lang="scss">
.navbar {
  position: relative;
  height: 3.5rem;
  width: 100%;

  // 背景层单独做渐隐：颜色与模糊一起用 mask 淡出，避免硬边
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: rgba(72, 118, 185, 0.48);
    backdrop-filter: blur(14px) saturate(1.15);
    -webkit-backdrop-filter: blur(14px) saturate(1.15);
    -webkit-mask-image: linear-gradient(
      to bottom,
      #000 0%,
      #000 20%,
      rgba(0, 0, 0, 0.88) 40%,
      rgba(0, 0, 0, 0.55) 60%,
      rgba(0, 0, 0, 0.22) 80%,
      transparent 100%
    );
    mask-image: linear-gradient(
      to bottom,
      #000 0%,
      #000 20%,
      rgba(0, 0, 0, 0.88) 40%,
      rgba(0, 0, 0, 0.55) 60%,
      rgba(0, 0, 0, 0.22) 80%,
      transparent 100%
    );
    pointer-events: none;
  }
}

.nav-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.nav-brand {
  .brand-title {
    font-size: 1.5rem;
    font-weight: 800;
    text-decoration: none;
    letter-spacing: 2px;
    transition: all 0.3s ease;
    font-family: "华文行楷", "楷体", cursive;
    
    // 渐变色文字
    background: linear-gradient(45deg, #4775c5, #2d5aa8);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    
    // 立体文字效果
    text-shadow: 
      2px 2px 0 rgba(71, 117, 197, 0.2),
      3px 3px 0 rgba(45, 90, 168, 0.1),
      4px 4px 8px rgba(0, 0, 0, 0.1);
    
    &:hover {
      transform: translateY(-2px) scale(1.02);
      background: linear-gradient(45deg, #2d5aa8, #4775c5);
      -webkit-background-clip: text;
      background-clip: text;
      text-shadow: 
        2px 2px 0 rgba(71, 117, 197, 0.3),
        3px 3px 0 rgba(45, 90, 168, 0.2),
        4px 4px 12px rgba(0, 0, 0, 0.2);
    }
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  text-decoration: none;
  color: rgba(45, 90, 168, 0.8);
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  .nav-icon {
    font-size: 1.1rem;
    transition: transform 0.3s ease;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    color: #2d5aa8;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(45, 90, 168, 0.2);
    
    .nav-icon {
      transform: scale(1.2) rotate(5deg);
    }
    
    &::before {
      left: 100%;
    }
  }
  
  &.router-link-active {
    background: linear-gradient(135deg, rgba(45, 90, 168, 0.9), rgba(71, 117, 197, 0.9));
    color: white;
    box-shadow: 
      0 4px 15px rgba(45, 90, 168, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    
    .nav-icon {
      transform: scale(1.1);
    }
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .nav-links {
    gap: 1rem;
  }
  
  .nav-item {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
    
    span {
      display: none;
    }
    
    .nav-icon {
      font-size: 1.2rem;
    }
  }
}

@media (max-width: 768px) {
  .nav-brand .brand-title {
    font-size: 1.2rem;
    letter-spacing: 1px;
  }
  
  .nav-links {
    gap: 0.5rem;
  }
  
  .nav-item {
    padding: 0.3rem 0.5rem;
  }
}
</style> 